(function (angular) {
    var SliderController = (function () {
        function SliderController() {
            this.init.apply(this, arguments);
        }

        SliderController.prototype = {
            init: function ($scope, $element, $interval, $timeout, $rootScope) {
                var _self = this;
                $scope.vm = this;
                this.$scope = $scope;
                this.$element = $element;
                this.$interval = $interval;
                this.$timeout = $timeout;
                this.$rootScope = $rootScope;
                var step = parseFloat(this.$scope.step),
                    min = parseInt(this.$scope.min),
                    max = parseInt(this.$scope.max);

                this.disabled = false;
                if (!!this.$scope.disabled) {
                    this.disabled = this.$scope.disabled;
                }
                this.$element.slider({
                    orientation: "vertical",
                    min: min,
                    max: max,
                    step: step,
                    animate: false,
                    range: this.$scope.range,
                    value: parseFloat(this.$scope.ngModel),
                    slide: angular.bind(this, function (event, ui) {
                        // NF-410: in case of disabled, we do nothing
                        if (this.disabled) { return; }
                        if(ui.value<this.$scope.minValue)
                            return false;
                        var value = ui.value;

                        var minVal = parseInt(this.$scope.min);
                        var maxVal = parseInt(this.$scope.max)

                        if (this.$scope.revertion) {
                            value = maxVal + minVal - value;
                        }
                        
                        if (this.$scope.round)
                            value = Math.round(value);
                        this.$scope.ngModel = value;
                        if(this.$scope.slide)
                            this.$scope.slide({
                                value:value,
                                event:event,
                                ui:ui
                            });
                        this.safeApply();
                    })
                });

                this.$scope.$watch("min", function (min) {
                    // console.log('-----min change to ', min);
                    _self.min = min;
                    _self.$element.slider( "option", "min", parseInt(min));
                });
                this.$scope.$watch("max", function (max) {
                    // console.log('-----max change to ', max);
                    _self.max = max;
                    _self.$element.slider( "option", "max", parseInt(max));
                });
            },
            safeApply: function (fn) {
                var phase = this.$scope.$root.$$phase;
                if (phase == '$apply' || phase == '$digest') {
                    if (fn && (typeof(fn) === 'function')) {
                        fn();
                    }
                } else {
                    this.$scope.$apply(fn);
                }
            }
        };
        SliderController.$inject = ['$scope', '$element', '$interval', '$timeout', '$rootScope'];
        return SliderController;
    }());

    angular.module('shared').directive('nfSlider', function () {
        return {
            restrict: 'E',
            controller: SliderController,
            scope: {
                ngModel: '=',
                value: '=',
                min: '@',
                max: '@',
                step: '@',
                round: '@',
                revertion: '@',
                minValue:'=',
                slide:'&',
                range:'@',
                disabled:'='
            }
        };
    });

}(angular));